import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Button from '../button';
import AsideCard from '../../screens/sharing/components/aside-card';
import {
	dismissAnnouncement,
	getLatestActiveAnnouncement
} from './announcementsConfig';
import './index.css';

function FeatureAnnouncementBannerComponent(props) {
	const { history } = props;
	const profile = useSelector(state => state.profileReducer.getProfile);
	const { t } = useTranslation();
	const [activeAnnouncement, setActiveAnnouncement] = useState(() =>
		getLatestActiveAnnouncement(profile)
	);

	useEffect(() => {
		setActiveAnnouncement(getLatestActiveAnnouncement(profile));

		const handleStorageChange = () => {
			setActiveAnnouncement(getLatestActiveAnnouncement(profile));
		};

		window.addEventListener('cf-announcement-dismissed', handleStorageChange);
		return () => {
			window.removeEventListener('cf-announcement-dismissed', handleStorageChange);
		};
	}, [profile]);

	if (!activeAnnouncement) {
		return null;
	}

	const handleDismiss = (e) => {
		if (e) {
			e.stopPropagation();
		}
		dismissAnnouncement(activeAnnouncement.id, profile && profile.id);
		setActiveAnnouncement(null);
	};

	const handleCtaClick = () => {
		const route = activeAnnouncement.ctaRoute;
		dismissAnnouncement(activeAnnouncement.id, profile && profile.id);
		setActiveAnnouncement(null);
		if (route && history) {
			history.push(route);
		}
	};

	return (
		<div className="feature-announcement-banner" role="region" aria-label="New feature announcement">
			<div className="feature-announcement-banner__inner">
				<span className="feature-announcement-banner__badge">
					{t(activeAnnouncement.badgeKey, 'NEW')}
				</span>
				<span className="feature-announcement-banner__text">
					<strong>
						{t(activeAnnouncement.titleKey, 'Take control of license consumption with the new "Restricted User" role!')}
					</strong>
					{' '}
					{t(activeAnnouncement.descriptionKey, 'Prevent non-admin users from sharing labels and consuming extra licenses.')}
				</span>
				<button
					type="button"
					className="feature-announcement-banner__link"
					onClick={handleCtaClick}
				>
					{t(activeAnnouncement.ctaLabelKey, 'Manage User Roles')}
				</button>
			</div>
			<button
				type="button"
				className="feature-announcement-banner__close"
				onClick={handleDismiss}
				aria-label={t('closeBtn', 'Close')}
				title={t('closeBtn', 'Close')}
			>
				&times;
			</button>
		</div>
	);
}

function FeatureAnnouncementAsideCardComponent(props) {
	const { history } = props;
	const profile = useSelector(state => state.profileReducer.getProfile);
	const { t } = useTranslation();
	const [activeAnnouncement, setActiveAnnouncement] = useState(() =>
		getLatestActiveAnnouncement(profile)
	);

	useEffect(() => {
		setActiveAnnouncement(getLatestActiveAnnouncement(profile));

		const handleStorageChange = () => {
			setActiveAnnouncement(getLatestActiveAnnouncement(profile));
		};

		window.addEventListener('cf-announcement-dismissed', handleStorageChange);
		return () => {
			window.removeEventListener('cf-announcement-dismissed', handleStorageChange);
		};
	}, [profile]);

	if (!activeAnnouncement) {
		return null;
	}

	const handleDismiss = (e) => {
		if (e) {
			e.stopPropagation();
		}
		dismissAnnouncement(activeAnnouncement.id, profile && profile.id);
		setActiveAnnouncement(null);
	};

	const handleCtaClick = () => {
		const route = activeAnnouncement.ctaRoute;
		dismissAnnouncement(activeAnnouncement.id, profile && profile.id);
		setActiveAnnouncement(null);
		if (route && history) {
			history.push(route);
		}
	};

	return (
		<AsideCard>
			<div className="feature-announcement-aside position-relative">
				<button
					type="button"
					className="feature-announcement-aside__close"
					onClick={handleDismiss}
					aria-label={t('closeBtn', 'Close')}
					title={t('closeBtn', 'Close')}
				>
					×
				</button>
				<div className="mb-2">
					<span className="feature-announcement-banner__badge">
						{t(activeAnnouncement.badgeKey, 'NEW')}
					</span>
				</div>
				<h2>
					{t(activeAnnouncement.titleKey, 'Restricted User Role')}
				</h2>
				<p>
					{t(
						activeAnnouncement.asideDescriptionKey || activeAnnouncement.descriptionKey,
						'Control your license consumption: set new users as Restricted by default or bulk-update existing users so they cannot share labels.'
					)}
				</p>
				<Button
					className="btn-primary d-flex align-items-center justify-content-center w-100"
					onClick={handleCtaClick}
				>
					<span className="text-truncate">
						{t(activeAnnouncement.asideCtaLabelKey || activeAnnouncement.ctaLabelKey, 'Configure Roles')}
					</span>
				</Button>
			</div>
		</AsideCard>
	);
}

export const FeatureAnnouncementBanner = withRouter(FeatureAnnouncementBannerComponent);
export const FeatureAnnouncementAsideCard = withRouter(FeatureAnnouncementAsideCardComponent);

export default FeatureAnnouncementBanner;
